var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[(_vm.options.results.length)?_c('SliderTile',{attrs:{"classes":"py-sm-7 px-sm-5","sliderOccasions":_vm.options.results.slice(0, 6)}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }